import React from 'react';
import { Box, Typography } from '@mui/material';

// Lichte markdown-preview voor offerte-omschrijvingen (## koppen, - bullets,
// **bold**, genummerde deliverables). Bewust geen dependency — de omschrijvingen
// gebruiken maar een klein, vast subset van markdown.
function renderInline(text, keyPrefix = '') {
  const parts = String(text).split(/(\*\*[^*]+\*\*)/g).filter(Boolean);
  return parts.map((p, i) =>
    p.startsWith('**') && p.endsWith('**')
      ? <Box key={`${keyPrefix}b${i}`} component="strong" sx={{ fontWeight: 700 }}>{p.slice(2, -2)}</Box>
      : <React.Fragment key={`${keyPrefix}t${i}`}>{p}</React.Fragment>
  );
}

export default function MarkdownPreview({ text, sx = {} }) {
  const lines = String(text || '').split('\n');
  const blocks = [];
  let list = null;
  const flushList = () => { if (list) { blocks.push({ type: 'ul', items: list }); list = null; } };

  for (const raw of lines) {
    const line = raw.trim();
    if (!line) { flushList(); continue; }
    const h = line.match(/^#{1,6}\s+(.*)$/);
    if (h) { flushList(); blocks.push({ type: 'h', text: h[1] }); continue; }
    const li = line.match(/^[-*]\s+(.*)$/);
    if (li) { (list = list || []).push(li[1]); continue; }
    flushList();
    blocks.push({ type: 'p', text: line, numbered: /^\d{2}\.\s/.test(line) });
  }
  flushList();

  return (
    <Box sx={{ px: 2.5, py: 2, bgcolor: '#fff', border: '1px solid #e5e7eb', borderRadius: 1.5, ...sx }}>
      {blocks.map((b, i) => {
        if (b.type === 'h') return (
          <Typography key={i} sx={{ fontWeight: 800, fontSize: 15, color: '#3b5bdb', mt: i === 0 ? 0 : 2, mb: 0.5 }}>
            {b.text}
          </Typography>
        );
        if (b.type === 'ul') return (
          <Box key={i} component="ul" sx={{ m: 0, mb: 1, pl: 2.5 }}>
            {b.items.map((it, k) => (
              <li key={k}><Typography variant="body2" sx={{ lineHeight: 1.7 }}>{renderInline(it, `${i}-${k}`)}</Typography></li>
            ))}
          </Box>
        );
        return (
          <Typography key={i} variant="body2" sx={{ mb: b.numbered ? 0.25 : 1, lineHeight: 1.7 }}>
            {renderInline(b.text, `${i}`)}
          </Typography>
        );
      })}
    </Box>
  );
}
